import React from 'react'
import PropTypes from 'prop-types'
import wfLogo from '../../../../../../data/img/webfleet-logo.svg'

import styles from './header.module.css'

const WfLogo = ({ phoneLabel, phoneNumber }) => {
    const goToWebfleet = () => {
        window.open(`https://webfleet.com`, '_blank')
    }

    return (
        <div className={styles['wf-logo-header']}>
            <div className={styles['wf-logo-box']}>
                <img onClick={goToWebfleet} className={styles['wf-logo-image']} src={wfLogo} />
            </div>
            <div className={styles['wf-logo-phone-box']}>
                <div>{phoneLabel}</div>
                <div className={styles['phone-number']}>{phoneNumber}</div>
            </div>
        </div>
    )
}

const AppHeader = ({ phoneLabel, phoneNumber, subtitle, title }) => {
    return (
        <header>
            <div className={styles['top-stripe-short']} />
            <WfLogo {...{ phoneLabel, phoneNumber }} />
            <div className={styles['top-stripe']} />
            <div className={styles['header-container']}>
                <div className={styles['header-title']}>{title}</div>
                <div className={styles['header-subtitle']}>{subtitle}</div>
            </div>
        </header>
    )
}

WfLogo.propTypes = {
    phoneLabel: PropTypes.string,
    phoneNumber: PropTypes.string
}

AppHeader.propTypes = {
    phoneLabel: PropTypes.string,
    phoneNumber: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string
}

export { AppHeader }
